import api from './api';

class AchatsService {
  async getFactures(params = {}) {
    const response = await api.get('/achats', { params });
    return response.data;
  }

  async getKPIs() {
    const response = await api.get('/achats/kpis');
    return response.data;
  }

  async getFactureById(id) {
    const response = await api.get(`/achats/${id}`);
    return response.data;
  }

  async createFacture(factureData) {
    const response = await api.post('/achats', factureData);
    return response.data;
  }

  async annulerFacture(id) {
    const response = await api.delete(`/achats/${id}`);
    return response.data;
  }
}

export default new AchatsService();
